export default __webpack_public_path__ + "static/media/cal_bg13.d35cc651.jpg";